import { render, staticRenderFns } from "./02_RegisterDataForm.vue?vue&type=template&id=0cda9dd3&"
import script from "./02_RegisterDataForm.vue?vue&type=script&lang=js&"
export * from "./02_RegisterDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports